module.exports = __webpack_public_path__ + "static/img/smart_guard.cd40566f.png";